import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import {
//     AnimatedTransitionGroup,
//     AnimatedChild,
// } from 'animated-transition-group'
import classnames from 'classnames'

import ErrorBoundary from 'components/ErrorBoundary'
import Universal from 'components/Universal'
import Footer from 'layouts/Footer'

import selector from './selectors'
import styles from './styles.css'

const Switch = ({ id, component, pageType, footerless, account }) => (
  // Transition disabled for now since it seems to trigger twice on page load,
  // which is very annoying.
  // <AnimatedTransitionGroup
  //     component="div"
  //     className={styles.root}
  //     appear={styles.appear}
  //     enter={styles.enter}
  //     leave={styles.leave}
  //     duration={500}
  //     debounce={500}
  // >
  //     <AnimatedChild key={id}>
  <div
    // Remove this key if you enable the AnimatedTransitionGroup.
    key={id}
    className={classnames({ [styles.footerWrapper]: !footerless })}
  >
    <ErrorBoundary from="switch">
      <Universal component={component} pageType={pageType} />
    </ErrorBoundary>
    {!footerless && <Footer account={account} />}
  </div>
  //     </AnimatedChild>
  // </AnimatedTransitionGroup>
)

Switch.propTypes = {
  id: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  pageType: PropTypes.string.isRequired,
  footerless: PropTypes.bool,
  account: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
}

Switch.defaultProps = {
  footerless: false,
  account: false,
}

export default connect(selector)(Switch)



// WEBPACK FOOTER //
// ../source/views/Switch/index.js